import { css } from 'lit';

export default css`:root --fs-focus-indicator {
    outline: 0;
  }

  :root --fs-focus-indicator--default {
    outline: 0;
    box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));
  }

  :root --fs-focus-indicator--high-contrast {
    outline: 0;
    box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-high-contrast, hsl(0, 0%, 8%)), 0 0 0 4px var(--fs-color-focus-primary-high-contrast, hsl(0, 0%, 100%));
  }

  :root --fs-text-base {
      font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
      margin: var(--fs-size-spacing-none, 0);
    }

  :root --fs-text-weight--light {
      font-weight: var(--fs-font-weight-light, 300);
    }

  :root --fs-text-weight--regular {
      font-weight: var(--fs-font-weight-regular, 400);
    }

  :root --fs-text-weight--extra-light {
      font-weight: var(--fs-font-weight-extra-light, 100);
    }

  :root --fs-text-weight--semibold {
      font-weight: var(--fs-font-weight-semibold, 600);
    }

  :root --fs-text-size--small-1 {
      font-size: var(--fs-font-size-small1, 0.75rem);
    }

  :root --fs-text-size--small-2 {
      font-size: var(--fs-font-size-small2, 0.875rem);
    }

  :root --fs-text-size--medium-1 {
      font-size: var(--fs-font-size-medium1, 1rem);
    }

  :root --fs-text-size--medium-2 {
      font-size: var(--fs-font-size-medium2, 1.25rem);
    }

  :root --fs-text-size--medium-3 {
      font-size: var(--fs-font-size-medium3, 1.5rem);
    }

  :root --fs-text-size--large-1 {
      font-size: var(--fs-font-size-large1, 2rem);
    }

  :root --fs-text-size--large-2 {
      font-size: var(--fs-font-size-large2, 2.5rem);
    }

  :root --fs-text-size--large-3 {
      font-size: var(--fs-font-size-large3, 3rem);
    }

  :root --fs-text-size--xlarge-1 {
      font-size: var(--fs-font-size-xlarge1, 4rem);
    }

  :root --fs-text-color--primary {
      color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
    }

  :root --fs-text-color--secondary {
      color: var(--fs-text-color-secondary, hsl(0, 0%, 41%));
    }

  :root --fs-text-color--inverse {
      color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));
    }

  :root --fs-text-color--disabled {
      color: var(--fs-text-color-disabled, hsl(0, 0%, 49%));
    }

  :root --fs-text-color--feedback-positive {
      color: var(--fs-text-color-link-feedback-positive, hsl(108, 80%, 28%));
    }

  :root --fs-text-color--feedback-negative {
      color: var(--fs-text-color-link-feedback-negative, hsl(359, 70%, 47%));
    }

  :root --fs-heading-text--xxlarge {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-xxlarge, 4rem);
        font-weight: var(--fs-font-weight-extra-light, 100);
        line-height: var(--fs-font-line-height-tiny, 1.2);
      }

  :root --fs-heading-text--xlarge {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-xlarge, 3rem);
        font-weight: var(--fs-font-weight-extra-light, 100);
        line-height: var(--fs-font-line-height-small, 1.3);
      }

  :root --fs-heading-text--large {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-large, 2rem);
        font-weight: var(--fs-font-weight-light, 300);
        line-height: var(--fs-font-line-height-small, 1.3);
      }

  :root --fs-heading-text--medium {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-medium, 1.25rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-heading-text--normal {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-normal, 1rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-heading-text--small {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-small, 0.875rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-heading-text--tiny {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-heading-tiny, 0.75rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-body-text--medium {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-body-medium, 1.25rem);
        font-weight: var(--fs-font-weight-regular, 400);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-body-text--normal {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-body-normal, 1rem);
        font-weight: var(--fs-font-weight-regular, 400);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-body-text--small {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-body-small, 0.875rem);
        font-weight: var(--fs-font-weight-regular, 400);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-body-text--tiny {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-body-tiny, 0.75rem);
        font-weight: var(--fs-font-weight-regular, 400);
        line-height: var(--fs-font-line-height-normal, 1.5);
      }

  :root --fs-overline-text--normal {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-overline-normal, 1rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        letter-spacing: 1px;
        line-height: var(--fs-font-line-height-normal, 1.5);
        text-transform: uppercase;
      }

  :root --fs-overline-text--small {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-overline-small, 0.875rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        letter-spacing: 1px;
        line-height: var(--fs-font-line-height-normal, 1.5);
        text-transform: uppercase;
      }

  :root --fs-overline-text--tiny {
        color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
        font-size: var(--fs-font-overline-tiny, 0.75rem);
        font-weight: var(--fs-font-weight-semibold, 600);
        letter-spacing: 1px;
        line-height: var(--fs-font-line-height-normal, 1.5);
        text-transform: uppercase;
      }

  :root --fs-text--inverse {
      color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));
    }

  :root --fs-link {
      cursor: pointer;
      font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
      text-decoration: underline;
    }

  :root --fs-link--primary-default {
      color: var(--fs-text-color-link-primary-default, hsl(200, 98%, 35%));
    }

  :root --fs-link--primary-hover {
      color: var(--fs-text-color-link-primary-hover, hsl(200, 97%, 30%));
    }

  :root --fs-link--primary-focus {
      
  outline: 0;

      
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

      border-radius: var(--fs-radius-small, 4px);
      color: var(--fs-text-color-link-primary-focus, hsl(200, 97%, 30%));
    }

  :root --fs-link--primary-active {
      color: var(--fs-text-color-link-primary-active, hsl(200, 98%, 23%));
    }

  :root --fs-link--secondary-default {
      color: var(--fs-text-color-link-secondary-default, hsl(0, 0%, 41%));
    }

  :root --fs-link--secondary-hover {
      color: var(--fs-text-color-link-secondary-hover, hsl(0, 0%, 32%));
    }

  :root --fs-link--secondary-focus {
      
  outline: 0;

      
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

      border-radius: var(--fs-radius-small, 4px);
      color: var(--fs-text-color-link-secondary-focus, hsl(0, 0%, 32%));
    }

  :root --fs-link--secondary-active {
      color: var(--fs-text-color-link-secondary-active, hsl(0, 0%, 24%));
    }

  :root --fs-link--inverse-default {
      color: var(--fs-text-color-link-inverse-default, hsl(0, 0%, 100%));
    }

  :root --fs-link--inverse-hover {
      color: var(--fs-text-color-link-inverse-hover, hsl(0, 0%, 96%));
    }

  :root --fs-link--inverse-focus {
      
  outline: 0;

      
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

      border-radius: var(--fs-radius-small, 4px);
      color: var(--fs-text-color-link-inverse-focus, hsl(0, 0%, 96%));
    }

  :root --fs-link--inverse-active {
      color: var(--fs-text-color-link-inverse-active, hsl(0, 0%, 90%));
    }

  :root --fs-link--visited {
      color: var(--fs-text-color-link-primary-visited, hsl(270, 50%, 40%));
    }

  :root --fs-link--visited-inverse {
      color: var(--fs-text-color-link-inverse-visited, hsl(0, 0%, 100%));
    }

  :root --fs-link-standalone {
      line-height: var(--fs-font-line-height-normal, 1.5);
      text-decoration: none;
    }

  :root --fs-link-standalone--medium {
      font-size: var(--fs-font-size-medium2, 1.25rem);
    }

  :root --fs-link-standalone--normal {
      font-size: var(--fs-font-size-medium1, 1rem);
    }

  :root --fs-link-standalone--small {
      font-size: var(--fs-font-size-small2, 0.875rem);
    }

  :root --fs-link-standalone--tiny {
      font-size: var(--fs-font-size-small1, 0.75rem);
    }


  .fs-heading-text,
  .fs-body-text,
  .fs-overline-text,
  .fs-text {
    
  font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
  margin: var(--fs-size-spacing-none, 0);

  }

  .fs-heading-text--inverse,
  .fs-body-text--inverse,
  .fs-overline-text--inverse,
  .fs-text--inverse {
    
  color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));

  }

  .fs-text-weight--extra-light {
    
  font-weight: var(--fs-font-weight-extra-light, 100);

  }

  .fs-text-weight--light {
    
  font-weight: var(--fs-font-weight-light, 300);

  }

  .fs-text-weight--regular {
    
  font-weight: var(--fs-font-weight-regular, 400);

  }

  .fs-text-weight--semibold {
    
  font-weight: var(--fs-font-weight-semibold, 600);

  }

  .fs-text-size--small-1 {
    
  font-size: var(--fs-font-size-small1, 0.75rem);

  }

  .fs-text-size--small-2 {
    
  font-size: var(--fs-font-size-small2, 0.875rem);

  }

  .fs-text-size--medium-1 {
    
  font-size: var(--fs-font-size-medium1, 1rem);

  }

  .fs-text-size--medium-2 {
    
  font-size: var(--fs-font-size-medium2, 1.25rem);

  }

  .fs-text-size--medium-3 {
    
  font-size: var(--fs-font-size-medium3, 1.5rem);

  }

  .fs-text-size--large-1 {
    
  font-size: var(--fs-font-size-large1, 2rem);

  }

  .fs-text-size--large-2 {
    
  font-size: var(--fs-font-size-large2, 2.5rem);

  }

  .fs-text-size--large-3 {
    
  font-size: var(--fs-font-size-large3, 3rem);

  }

  .fs-text-size--xlarge-1 {
    
  font-size: var(--fs-font-size-xlarge1, 4rem);


  }

  .fs-heading-text--xxlarge {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-xlarge1, 4rem);
  font-weight: var(--fs-font-weight-extra-light, 100);
  line-height: var(--fs-font-line-height-tiny, 1.2);

  }

  .fs-heading-text--xlarge {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-large3, 3rem);
  font-weight: var(--fs-font-weight-extra-light, 100);
  line-height: var(--fs-font-line-height-small, 1.3);

  }

  .fs-heading-text--large {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-large1, 2rem);
  font-weight: var(--fs-font-weight-light, 300);
  line-height: var(--fs-font-line-height-small, 1.3);

  }

  .fs-heading-text--medium {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-medium2, 1.25rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-heading-text--normal {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-heading-normal, 1rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-heading-text--small {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small2, 0.875rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-heading-text--tiny {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small1, 0.75rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-heading-text--secondary {
    
  color: var(--fs-text-color-secondary, hsl(0, 0%, 41%));

  }

  .fs-heading-text--inverse {
    
  color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));

  }

  .fs-body-text--medium {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small1, 0.75rem);
  font-weight: var(--fs-font-weight-regular, 400);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-body-text--normal {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-medium1, 1rem);
  font-weight: var(--fs-font-weight-regular, 400);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-body-text--small {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small2, 0.875rem);
  font-weight: var(--fs-font-weight-regular, 400);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-body-text--tiny {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small1, 0.75rem);
  font-weight: var(--fs-font-weight-regular, 400);
  line-height: var(--fs-font-line-height-normal, 1.5);

  }

  .fs-body-text--inverse {
    
  color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));

  }

  .fs-overline-text--normal {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-medium1, 1rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  letter-spacing: 1px;
  line-height: var(--fs-font-line-height-normal, 1.5);
  text-transform: uppercase;

  }

  .fs-overline-text--small {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small2, 0.875rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  letter-spacing: 1px;
  line-height: var(--fs-font-line-height-normal, 1.5);
  text-transform: uppercase;

  }

  .fs-overline-text--tiny {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));
  font-size: var(--fs-font-size-small2, 0.875rem);
  font-weight: var(--fs-font-weight-semibold, 600);
  letter-spacing: 1px;
  line-height: var(--fs-font-line-height-normal, 1.5);
  text-transform: uppercase;

  }

  .fs-link {
    
  cursor: pointer;
  font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
  text-decoration: underline;

  }

  .fs-link--primary {
    
  color: var(--fs-text-color-link-primary-default, hsl(200, 98%, 35%));
  }

  .fs-link--primary:hover {
      
  color: var(--fs-text-color-link-primary-hover, hsl(200, 97%, 30%));

    }

  .fs-link--primary:focus {
      
  
  outline: 0;

  
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

  border-radius: var(--fs-radius-small, 4px);
  color: var(--fs-text-color-link-primary-focus, hsl(200, 97%, 30%));

    }

  .fs-link--primary:active {
      
  color: var(--fs-text-color-link-primary-active, hsl(200, 98%, 23%));

    }

  .fs-link--primary:visited {
      
  color: var(--fs-text-color-link-primary-visited, hsl(270, 50%, 40%));

    }

  .fs-link--secondary {
    
  color: var(--fs-text-color-link-secondary-default, hsl(0, 0%, 41%));
  }

  .fs-link--secondary:hover {
      
  color: var(--fs-text-color-link-secondary-hover, hsl(0, 0%, 32%));

    }

  .fs-link--secondary:focus {
      
  
  outline: 0;

  
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

  border-radius: var(--fs-radius-small, 4px);
  color: var(--fs-text-color-link-secondary-focus, hsl(0, 0%, 32%));

    }

  .fs-link--secondary:active {
      
  color: var(--fs-text-color-link-secondary-active, hsl(0, 0%, 24%));

    }

  .fs-link--secondary:visited {
      
  color: var(--fs-text-color-link-primary-visited, hsl(270, 50%, 40%));

    }

  .fs-link--inverse {
    
  color: var(--fs-text-color-link-inverse-default, hsl(0, 0%, 100%));
  }

  .fs-link--inverse:hover {
      
  color: var(--fs-text-color-link-inverse-hover, hsl(0, 0%, 96%));

    }

  .fs-link--inverse:focus {
      
  
  outline: 0;

  
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

  border-radius: var(--fs-radius-small, 4px);
  color: var(--fs-text-color-link-inverse-focus, hsl(0, 0%, 96%));

    }

  .fs-link--inverse:active {
      
  color: var(--fs-text-color-link-inverse-active, hsl(0, 0%, 90%));

    }

  .fs-link--inverse:visited {
      
  color: var(--fs-text-color-link-inverse-visited, hsl(0, 0%, 100%));

    }

  .fs-text-color--primary {
    
  color: var(--fs-text-color-primary, hsl(0, 0%, 8%));

  }

  .fs-text-color--secondary {
    
  color: var(--fs-text-color-secondary, hsl(0, 0%, 41%));

  }

  .fs-text-color--inverse {
    
  color: var(--fs-text-color-inverse, hsl(0, 0%, 100%));

  }

  .fs-text-color--disabled {
    
  color: var(--fs-text-color-disabled, hsl(0, 0%, 49%));

  }

  .fs-text-color--feedback-positive {
    
  color: var(--fs-text-color-link-feedback-positive, hsl(108, 80%, 28%));

  }

  .fs-text-color--feedback-negative {
    
  color: var(--fs-text-color-link-feedback-negative, hsl(359, 70%, 47%));

  }

  .fs-link-standalone {
    
  cursor: pointer;
  font-family: var(--fs-font-stack, Optimist, "Helvetica Neue", Helvetica, Arial, sans-serif);
  text-decoration: underline;

    
  color: var(--fs-text-color-link-primary-default, hsl(200, 98%, 35%));

    
  line-height: var(--fs-font-line-height-normal, 1.5);
  text-decoration: none;
  }

  .fs-link-standalone:hover {
      
  color: var(--fs-text-color-link-primary-hover, hsl(200, 97%, 30%));

    }

  .fs-link-standalone:focus {
      
  
  outline: 0;

  
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

  border-radius: var(--fs-radius-small, 4px);
  color: var(--fs-text-color-link-primary-focus, hsl(200, 97%, 30%));

    }

  .fs-link-standalone:active {
      
  color: var(--fs-text-color-link-primary-active, hsl(200, 98%, 23%));

    }

  .fs-link-standalone:visited {
      
  color: var(--fs-text-color-link-primary-visited, hsl(270, 50%, 40%));

    }

  .fs-link-standalone.fs-link-standalone--medium {
      
  font-size: var(--fs-font-size-medium2, 1.25rem);

    }

  .fs-link-standalone.fs-link-standalone--normal {
      
  font-size: var(--fs-font-size-medium1, 1rem);

    }

  .fs-link-standalone.fs-link-standalone--small {
      
  font-size: var(--fs-font-size-small2, 0.875rem);

    }

  .fs-link-standalone.fs-link-standalone--tiny {
      
  font-size: var(--fs-font-size-small1, 0.75rem);

    }

  .fs-link-standalone.fs-link-standalone--inverse {
      
  color: var(--fs-text-color-link-inverse-default, hsl(0, 0%, 100%));
    }

  .fs-link-standalone.fs-link-standalone--inverse:hover {
        
  color: var(--fs-text-color-link-inverse-hover, hsl(0, 0%, 96%));

      }

  .fs-link-standalone.fs-link-standalone--inverse:focus {
        
  
  outline: 0;

  
  outline: 0;
  box-shadow: 0 0 0 2px var(--fs-color-focus-secondary-default, hsl(0, 0%, 100%)), 0 0 0 4px var(--fs-color-focus-primary-default, hsl(200, 98%, 35%));

  border-radius: var(--fs-radius-small, 4px);
  color: var(--fs-text-color-link-inverse-focus, hsl(0, 0%, 96%));

      }

  .fs-link-standalone.fs-link-standalone--inverse:active {
        
  color: var(--fs-text-color-link-inverse-active, hsl(0, 0%, 90%));

      }`;